import { Sprout, Trees, Workflow } from 'lucide-react';
import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { townWeb } from '../web-manifest.js';

/**
 * Explicit `componentPath` keys must match manifest strings exactly —
 * `@reflex/plugin-town/web/FarmPage` etc. — so {@link rebuildMaps}
 * in `plugin-registry.ts` resolves them for routing and wiring audits.
 *
 * Icons use names that exactly match manifest `icon` fields (`Trees`,
 * `Workflow`, `Sprout`).
 */
export default createWebRegistration({
  components: {
    '@reflex/plugin-town/web/TownPage': () => import('./TownPage'),
    '@reflex/plugin-town/web/FlowTownPage': () => import('./FlowTownPage'),
    '@reflex/plugin-town/web/FarmPage': () => import('./FarmPage'),
  },
  icons: {
    Trees,
    Workflow,
    Sprout,
  },
  manifest: townWeb,
});
